"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const query_string_1 = __importDefault(require("query-string"));
const client_library_1 = require("@seneca/client-library");
const InvalidBodyFieldError_1 = __importDefault(require("./errors/InvalidBodyFieldError"));
/**
 * NotificationServiceClient
 * @param {any} fetch an object implementing the fetch api (for browsers this can be fetch.bind() for node require('node-fetch'))
 * @param {Object} options options object input data and dependency injection
 * @param {Object} options.fetch change fetch method from whatwg-fetch (optional, default: whatwg-fetch)
 * @param {string} options.protocol the http protocol of the service endpoint
 * @param {string} options.host the host of the service endpoint
 * @param {string} options.path the path of the service endpoint (optional)
 * @param {number} options.retries the number of times the client should retry on network error / service error (optional, default: 3)
 * @param {number} options.delayInSecs the delay between retries (optional, default: 2)
 * @param {Object} options.credentials identifiers and secrets required to hit protected endpoints (optional)
 * @param {string} options.region states the region of the service for signing (optional, default: eu-west-1)
 * @param {RequestMaker} options.requestMaker for overriding request making logic (optional, default: RequestMaker)
 * @throws {UrlConstructionError} when either options.protocol or options.host is missing
 */
class NotificationsServiceClient extends client_library_1.Client {
    constructor(fetch, options) {
        super(fetch, options);
    }
    async fetchMyNotificationPreferences({ type }) {
        return this._makeNotificationPreferencesRequest({
            method: 'GET',
            path: 'me',
            queryParams: {
                type
            }
        });
    }
    async updateMyNotificationPreferences({ preferences, type }) {
        return this._makeNotificationPreferencesRequest({
            method: 'PATCH',
            path: 'me',
            body: {
                preferences,
                type
            }
        });
    }
    async savePushNotificationsToken({ type, token }) {
        return this._makeNotificationPreferencesRequest({
            method: 'POST',
            path: 'push/token/me',
            body: {
                type,
                token
            }
        });
    }
    async deletePushNotificationsToken({ type, token }) {
        return this._makeNotificationPreferencesRequest({
            method: 'DELETE',
            path: 'push/token/me',
            body: {
                type,
                token
            }
        });
    }
    async unsubscribeUsersAdmin(emails) {
        return this._makeNotificationPreferencesRequest({
            method: 'PUT',
            path: 'unsubscribe',
            body: { emails },
            admin: true
        });
    }
    async savePreferencesAnonymous(body) {
        return this._makeNotificationPreferencesRequest({
            method: 'PUT',
            path: 'save',
            body
        });
    }
    async unsubscribeWithEncryptedTopic(encryptedContactKey) {
        return this._makeNotificationPreferencesRequest({
            method: 'PATCH',
            path: 'unsubscribe',
            body: {
                encryptedContactKey
            }
        });
    }
    _constructUrl(path) {
        let url = this.url;
        if (!this.url.endsWith('/'))
            url += '/';
        url += path;
        return url;
    }
    async _makeCommonRequest(baseUrl, method, path, body, queryParams) {
        let url = this._constructUrl(baseUrl);
        if (path)
            url += `/${path}`;
        const expectedResponses = [200, 404, 422];
        const options = { method };
        if (body)
            options.body = JSON.stringify(body);
        if (queryParams) {
            const params = query_string_1.default.stringify(queryParams);
            url = params.length > 0 ? `${url}?${params}` : url;
        }
        return this.requestMaker.makeRequest(url, options, expectedResponses);
    }
    async _makeNotificationPreferencesRequest({ method, path, body, queryParams, admin }) {
        const response = await this._makeCommonRequest(`api${admin ? '/admin' : ''}/preferences`, method, path, body, queryParams);
        if (response.status === 422) {
            const body = response.json;
            throw new InvalidBodyFieldError_1.default(body.pointer, body.reason);
        }
        if (response.status === 200 || response.status === 201) {
            return response.json;
        }
        // else 204 no exception or response body
        return;
    }
}
exports.default = NotificationsServiceClient;
//# sourceMappingURL=NotificationsServiceClient.js.map